import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "closeable", "onClose", "title", "titleText"];
import { Alert as AlertFoundations } from 'foundations-components/transitional/components/Alert';
import { useCloseableProps } from './useCloseableProps';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const Alert = _ref => {
  let {
      children,
      closeable = false,
      onClose,
      title,
      titleText
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const closeableProps = useCloseableProps({
    closeable,
    onClose
  });
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  return /*#__PURE__*/_jsx(AlertFoundations, Object.assign({}, rest, closeableProps, spacingProps, {
    titleText: title || titleText,
    children: children
  }));
};